/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ formats: NonNullable<unknown> }} Plain_Text_Import_Supported_Formats_LabelInputs */

const en_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supported formats: ${i?.formats}`)
};

const fr_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formats pris en charge : ${i?.formats}`)
};

const de_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unterstützte Formate: ${i?.formats}`)
};

const it_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formati supportati: ${i?.formats}`)
};

const ru_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Поддерживаемые форматы: ${i?.formats}`)
};

const es_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formatos admitidos: ${i?.formats}`)
};

const zh_cn2_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`支持的格式：${i?.formats}`)
};

const ja_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サポートされている形式: ${i?.formats}`)
};

const hi_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समर्थित प्रारूप: ${i?.formats}`)
};

const pt_pt2_plain_text_import_supported_formats_label = /** @type {(inputs: Plain_Text_Import_Supported_Formats_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formatos suportados: ${i?.formats}`)
};

/**
* | output |
* | --- |
* | "Supported formats: {formats}" |
*
* @param {Plain_Text_Import_Supported_Formats_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_supported_formats_label = /** @type {((inputs: Plain_Text_Import_Supported_Formats_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Supported_Formats_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_supported_formats_label(inputs)
	if (locale === "de") return de_plain_text_import_supported_formats_label(inputs)
	if (locale === "it") return it_plain_text_import_supported_formats_label(inputs)
	if (locale === "ru") return ru_plain_text_import_supported_formats_label(inputs)
	if (locale === "es") return es_plain_text_import_supported_formats_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_supported_formats_label(inputs)
	if (locale === "ja") return ja_plain_text_import_supported_formats_label(inputs)
	if (locale === "hi") return hi_plain_text_import_supported_formats_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_supported_formats_label(inputs)
	return en_plain_text_import_supported_formats_label(inputs)
});